import { render, staticRenderFns } from "./ci_resource_details.vue.js?vue&type=template&id=fa47af36&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_resource_details.vue?vue&type=template&id=fa47af36&vue3"
import script from "./ci_resource_details.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_resource_details.vue?vue&type=script&lang=js&vue3"
export * from "./ci_resource_details.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_resource_details.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports